import { render, staticRenderFns } from "./direction.vue?vue&type=template&id=730af326&"
import script from "./direction.vue?vue&type=script&lang=ts&"
export * from "./direction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports